import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import AuthGate from './components/AuthGate';
import DoorTest from './components/DoorTest';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const isDoorTest = false; // 문 테스트 모드: true=DoorTest, false=App

root.render(
  <React.StrictMode>
    {isDoorTest ? <DoorTest /> : <AuthGate><App /></AuthGate>}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
